<template>
  <v-row>
    <v-col cols="8">
      <v-autocomplete
        :items="stops"
        item-value="short_name"
        :item-text="item => `(${item.short_name}) ${item.stop_name}`"
        :filter="
          (item, query) =>
            item.short_name.toLowerCase().includes(query.toLowerCase()) ||
            item.stop_name.toLowerCase().includes(query.toLowerCase())
        "
        outlined
        label="Plats"
        v-model="location"
        :disabled="disabled"
        persistent-hint
      />
    </v-col>
  </v-row>
</template>

<script>
import { required } from '@/common/validationRules'
import { get, sync } from 'vuex-pathify'

export default {
  name: 'EventLocationField',

  props: {
    disabled: Boolean
  },

  data: () => ({
    required
  }),

  computed: {
    stops: get('event/stops'),
    location: sync('event/model@location')
  }
}
</script>
